import formatPrice from 'utils/formatPrice';

const getOrderLineTotalCost = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    return indexOrderLine
      ? formatPrice(indexOrderLine.Cost * indexOrderLine.Units).replace('$', '') : null;
  }
  return orderLine
    ? orderLine.map(item => formatPrice(item.Cost * item.Units).replace('$', '')).join(', ')
    : null;
};

export default getOrderLineTotalCost;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineTotalCost.js